import { Fragment } from 'react';

import UseContactConfirmation from './UseContactConfirmation';

import Headings from '../headings/Headings';
import PrimaryButton from '../buttons/PrimaryButton';
import SecondaryButton from '../buttons/SecondaryButton';
import ReadOnly from '../readOnly/ReadOnly';
import Input from '../inputs/Input';
import InternationalPhoneInput from '../inputs/InternationalPhoneInput';

import Constants from '../../utils/Constants';

const ContactConfirmation = ({ personId, onConfirmed, onCanceled }) => {
  const {
    isLoading,
    contactData,
    errorMessage,
    isEditing,
    formState,
    errorState,
    onEditClicked,
    onSaveClicked,
    onCancelEditClicked,
    onModalConfirmed,
    onFieldChanged,
    onPhoneNumberChanged
  } = UseContactConfirmation(personId, onConfirmed, onCanceled);

  console.log('personID: ' + personId);
  console.log('isEditing: ' + isEditing);
  console.log('formState:', formState);
  console.log('contactData:', contactData);

  // Function to format phone number for display
  const formatPhoneNumberForDisplay = (phoneNumber) => {
    if (!phoneNumber || phoneNumber.trim() === '' || phoneNumber === '+1') {
      return 'Not provided';
    }

    // Remove all non-digit characters except the + sign
    const cleanNumber = phoneNumber.replace(/[^\d+]/g, '');
    
    // Handle US/Canadian numbers (+1)
    if (cleanNumber.startsWith('1') && cleanNumber.length === 11) {
      const digits = cleanNumber.substring(1); // Remove 1
      return `+1 (${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
    }
    
    // Handle Mexican numbers (+52)
    if (cleanNumber.startsWith('52') && cleanNumber.length >= 12) {
      const digits = cleanNumber.substring(2); // Remove 52
      if (digits.length === 10) {
        return `+52 (${digits.substring(0, 2)}) ${digits.substring(2, 6)}-${digits.substring(6)}`;
      }
    }
    
    // For other formats or invalid numbers, return as-is
    return phoneNumber;
  };

  return (
    <Fragment>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <Headings.H5>Please confirm your contact information is correct:</Headings.H5>
        </div>
      </div>
      
      {isLoading ? (
        <div className="row">
          <div className="col-xs-12">
            <p>{Constants.LOADING_MSG}</p>
          </div>
        </div>
      ) : (
        <Fragment>
          {/* Email Address Row */}
          <div className="row">
            <div className="col-xs-12 col-sm-8 col-md-6">
              {isEditing ? (
                <Input
                  label="Email Address*"
                  name="email"
                  value={formState.emailAddress}
                  error={!!errorState.emailAddress}
                  message={errorState.emailAddress}
                  onChange={(value) => onFieldChanged('emailAddress', value)}
                />
              ) : (
                <ReadOnly
                  label="Email Address"
                  name="email"
                  value={contactData?.emailAddress || 'Not provided'}
                />
              )}
            </div>
          </div>
          
          {/* Phone Number Row */}
          <div className="row">
            <div className="col-xs-12 col-sm-8 col-md-6">
              {isEditing ? (
                <InternationalPhoneInput
                  label="Phone Number*"
                  name="phoneNumber"
                  value={formState.phoneNumber}
                  error={!!errorState.phoneNumber}
                  message={errorState.phoneNumber}
                  country="US"
                  onChange={(value) => {
                    console.log('InternationalPhoneInput onChange:', value);
                    onPhoneNumberChanged(value);
                  }}
                />
              ) : (
                <ReadOnly
                  label="Phone Number"
                  name="phoneNumber"
                  value={formatPhoneNumberForDisplay(contactData?.phoneNumber)}
                />
              )}
            </div>
          </div>
          
          {errorMessage && (
            <div className="row">
              <div className="col-xs-12">
                <p className="error-message">{errorMessage}</p>
              </div>
            </div>
          )}
          
          {!isEditing && (
            <div className="row usas-extra-top-margin">
              <div className="col-xs-12">
                <Headings.H5>Is this information correct?</Headings.H5>
              </div>
            </div>
          )}
        </Fragment>
      )}
      
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className="col-xs-12">
          {isEditing ? (
            <Fragment>
              <PrimaryButton 
                type="button" 
                onClick={onSaveClicked}
                isDisabled={isLoading}>
                Save Changes
              </PrimaryButton>&nbsp;&nbsp;
              <SecondaryButton 
                type="button" 
                onClick={onCancelEditClicked}>
                Cancel
              </SecondaryButton>
            </Fragment>
          ) : (
            <Fragment>
              <PrimaryButton 
                type="button" 
                onClick={onModalConfirmed}
                isDisabled={isLoading}>
                Yes, Continue
              </PrimaryButton>&nbsp;&nbsp;
              <SecondaryButton 
                type="button" 
                onClick={onEditClicked}
                isDisabled={isLoading}>
                Edit Information
              </SecondaryButton>&nbsp;&nbsp;
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default ContactConfirmation;